<template>
  <div class="opportunities-block_item">
    <div>
      <yellow-icon
        :icon="item.icon"
      />
    </div>
    <div
      ref="opportunity_title"
      class="opportunities-block_item-title">
      <span class="d-block">{{item.title}}</span>
    </div>
    <div class="opportunities-block_item-text">
      {{item.text}}
    </div>
  </div>
</template>

<script>
import YellowIcon from "./YellowIcon.vue";

export default {
  name: 'OpportunitiesBlockItem',
  components: {YellowIcon},
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>


